"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableEmojis = void 0;
const emoji_data_1 = require("./emoji-data");
const getAvailableEmojis = () => {
    return emoji_data_1.emojis;
};
exports.getAvailableEmojis = getAvailableEmojis;
